import Text from "@commons/Typography/Text";

type ListPreviewRowProps = {
  label: string;
  value: string | number | null | undefined;
};

function ListPreviewRow({ label, value }: ListPreviewRowProps) {
  return (
    <div className="flex justify-between items-start gap-4 min-w-52">
      <Text size="sm" className="font-roboto text-gray-600 flex-shrink-0">
        {label}
      </Text>
      <Text
        size="sm"
        className="font-roboto font-medium text-gray-800 text-right min-w-0"
      >
        {value ?? "-"}
      </Text>
    </div>
  );
}

export default ListPreviewRow;
